// extracted by mini-css-extract-plugin
export default {"button":"StylePrimarySmallTrueDar1_button__DHud+","styleprimarySmalltrueDar":"StylePrimarySmallTrueDar1_styleprimarySmalltrueDar__jqtj7"};